import Star from '@/assets/graphical-elements/star.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const StarIcon = ({className}: IconProps) => <Star className={cn('fill-current', className)} />
